<div *ngIf="!levelFilter" [ngClass]="{'stars': !small, 'smallStars': small}" [ngStyle]="{'cursor: default': readOnly}">
  <i class="pi pi-star-o" (click)="handleLevelChange(1)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(2)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(3)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(4)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(5)"></i>
</div>
<div *ngIf="levelFilter === 1" [ngClass]="{'stars': !small, 'smallStars': small}" [ngStyle]="{'cursor': readOnly ? 'default' : 'pointer'}">
  <i class="pi pi-star" (click)="handleLevelChange(1)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(2)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(3)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(4)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(5)"></i>
</div>
<div *ngIf="levelFilter === 2" [ngClass]="{'stars': !small, 'smallStars': small}" [ngStyle]="{'cursor': readOnly ? 'default' : 'pointer'}">
  <i class="pi pi-star" (click)="handleLevelChange(1)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(2)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(3)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(4)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(5)"></i>
</div>
<div *ngIf="levelFilter === 3" [ngClass]="{'stars': !small, 'smallStars': small}" [ngStyle]="{'cursor': readOnly ? 'default' : 'pointer'}">
  <i class="pi pi-star" (click)="handleLevelChange(1)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(2)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(3)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(4)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(5)"></i>
</div>
<div *ngIf="levelFilter === 4" [ngClass]="{'stars': !small, 'smallStars': small}" [ngStyle]="{'cursor': readOnly ? 'default' : 'pointer'}">
  <i class="pi pi-star" (click)="handleLevelChange(1)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(2)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(3)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(4)"></i>
  <i class="pi pi-star-o" (click)="handleLevelChange(5)"></i>
</div>
<div *ngIf="levelFilter === 5" [ngClass]="{'stars': !small, 'smallStars': small}" [ngStyle]="{'cursor': readOnly ? 'default' : 'pointer'}">
  <i class="pi pi-star" (click)="handleLevelChange(1)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(2)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(3)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(4)"></i>
  <i class="pi pi-star" (click)="handleLevelChange(5)"></i>
</div>
